export default __webpack_public_path__ + "static/media/bp-logo-colour.961f407d.svg";